import { render, staticRenderFns } from "./pm-numeric-keyboard.vue?vue&type=template&id=2f7820b7&"
import script from "./pm-numeric-keyboard.vue?vue&type=script&lang=js&"
export * from "./pm-numeric-keyboard.vue?vue&type=script&lang=js&"
import style0 from "./pm-numeric-keyboard.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports